<template>
  <div>
    <div class="left-aside">
      <div class="registration-form">
        <div class="brand">
          <router-link to="/Login"><img :src="require('@/assets/img/logo-management.svg')" alt=""></router-link>
        </div>
        <div class="hero-txt">
          <h2>Change Password</h2><span>Enter your new password to start your session.</span>
        </div>
        <form class="form-signin" @submit="sub">
          <div class="custom-control" v-if="errorMessage">
            <div class="error-message" for="customCheck1">{{ errorMessage }}</div>
          </div>
          <div class="form-label-group">
            <label for="inputEmail">New Password</label>
            <div class="form-forgot">
              <input :type="newPassword" id="inputEmail" class="form-control has-error" placeholder="New Password" autofocus v-model="user.password">
              <div v-if="showNewPassword == false">
                <button class="btn-forgot" type="button" @click="switchVisibilityNewPassword"><span><img :src="assets + 'icon-show-pass.svg'" alt=""></span></button>
              </div>
              <div v-if="showNewPassword == true">
                <button class="btn-forgot act" type="button" @click="switchVisibilityNewPassword"><span><img :src="assets + 'icon-show-pass.svg'" alt=""></span></button>
              </div>
            </div>
          </div>
          <div class="form-label-group">
            <label for="inputPassword">Confirm Password</label>
            <div class="form-forgot">
              <input :type="confirmPassword" id="inputPassword" class="form-control" placeholder="Confirm Password" name="current-password" v-model="user.confirmPassword">
              <div v-if="showConfirmPassword == false">
                <button class="btn-forgot" type="button" @click="switchVisibilityConfirmPassword"><span><img :src="assets + 'icon-show-pass.svg'" alt=""></span></button>
              </div>
              <div v-if="showConfirmPassword == true">
                <button class="btn-forgot act" type="button" @click="switchVisibilityConfirmPassword"><span><img :src="assets + 'icon-show-pass.svg'" alt=""></span></button>
              </div>
            </div>
          </div>
          <br>
          <button class="btn btn-lg btn-primary btn-block" type="submit" :disabled="isSubmitDisabled">Submit</button>
          <br clear="all">
          <router-link to="/ForgotPassword" class="btn btn-default btn-lg btn-block">Back</router-link>
          <br>
          <span class="txt-center">Don't have an account? <a href="#/Registration" class="">Register</a></span>
          <span class="txt-center"> or go back to <a href="#/Login" class="">Login</a></span>
        </form>
      </div>
    </div>
    <div class="right-aside"><img :src="assets + 'register-gfx.jpg'" alt=""></div>
  </div>
</template>

<script>
import { post, objectToQuerystring } from '@/utils/http';
import { isPassword, isConfirmPassword } from '@/utils/data-dictionary';

export default {
  name: 'ChangePassword',
  data() {
    return {
      assets: process.env.VUE_APP_ASSETS,
      errorMessage: "",
      isSubmitDisabled: false,
      user: {
        password: null,
        confirmPassword: null
      },
      step: 1,
      newPassword: 'password',
      confirmPassword: 'password',
      showNewPassword: false,
      showConfirmPassword: false
    }
  },
  computed: {
    changePassword() {
      return this.$store.getters.changePassword
    }
  },
  mounted() {
    if (this.changePassword == null) {
      this.$router.push("/Login");
    }
  },
  methods: {
    sub: function (event) {
      event.preventDefault();
      this.errorMessage = "";
      if (!isPassword(this.user.password) && !isPassword(this.user.confirmPassword)) {
        this.errorMessage = "Please enter valid password.";
      } else if (!isConfirmPassword(this.user.password, this.user.confirmPassword)) {
        this.errorMessage = "New Password and Confirm Password does not match.";
      } else {
        this.sendVerficationCode();
      }
    },
    sendVerficationCode() {
      this.changePassword.password = this.user.password;
      post("/Api/ChangePassword/", this.changePassword, (response) => {
        if (response.data.status == 'OK') {
          location.href = "/Authenticating" + objectToQuerystring(this.changePassword.authorization);
        } else {
          this.$toasted.show(response.data.message);
        }
        this.isSubmitDisabled = false;
      })
    },
    switchVisibilityNewPassword() {
      event.preventDefault();
      this.newPassword = this.newPassword === 'password' ? 'text' : 'password';
      this.showNewPassword = !this.showNewPassword;
    },
    switchVisibilityConfirmPassword() {
      event.preventDefault();
      this.confirmPassword = this.confirmPassword === 'password' ? 'text' : 'password';
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }
}
</script>
